import { LabelWithUnit } from 'components/secondaryMarket/shared/Label';
import { AmountWithUnit } from 'components/shared/Amount/Amount';
import { FC } from 'react';

import { Block } from '../../../shared/Blocks/Block';
import { VerticalFormGroup } from '../../../shared/VerticalFormGroup';

const fieldIds: string[] = ['xMarginPlusUpfront', 'tradingPrice', 'salesMargin'];

export type SalesMarginInformationProps = Readonly<{
  tabId: string;
  className?: string;

  salesMarginPlusUpfront: number | undefined;
  upfront: number | undefined;
  salesMarginAdjusted: number | undefined;
  tradingPriceAdjusted: number | undefined;
  amountUnit: string;
  isFrozen: boolean;

  onTradingPriceChanged: (value: number | undefined) => void;
  onSalesMarginChanged: (value: number | undefined) => void;
}>;

export const CpOrderSalesMarginInformation: FC<SalesMarginInformationProps> = ({
  className,
  upfront,
  tradingPriceAdjusted: tradingPrice,
  salesMarginAdjusted: salesMargin,
  onTradingPriceChanged,
  onSalesMarginChanged,
  salesMarginPlusUpfront,
  amountUnit,
  isFrozen,
}) => {
  return (
    <Block
      className={className}
      label="secondaryMarket.saleMarginInformation.label.title"
      id="sales-margin-information"
      fieldIds={fieldIds}
    >
      <div>
        <div className="row">
          <VerticalFormGroup
            inputId="salesMarginPlusUpfront"
            label="secondaryMarket.saleMarginInformation.salesMarginPlusUpfront"
            className="col-md-6"
          >
            {salesMarginPlusUpfront !== undefined && (
              <LabelWithUnit
                id="salesMarginPlusUpfront"
                value={salesMarginPlusUpfront.toFixed(4)}
                unit={amountUnit}
                e2e="sales-margin-plus-upfront"
              />
            )}
          </VerticalFormGroup>
          <VerticalFormGroup
            inputId="upfront"
            label="secondaryMarket.saleMarginInformation.upfront"
            className="col-md-6"
          >
            {upfront !== undefined && (
              <LabelWithUnit id="upfront" value={upfront.toFixed(4)} unit={amountUnit} e2e="upfront" />
            )}
          </VerticalFormGroup>
        </div>
        <div className="row">
          <VerticalFormGroup
            inputId="tradingPrice"
            label="secondaryMarket.saleMarginInformation.tradingPriceAdjusted"
            className="col-md-6"
          >
            <AmountWithUnit
              id="tradingPrice"
              value={tradingPrice}
              onChange={onTradingPriceChanged}
              unit={amountUnit}
              e2e="tradingPriceAdjusted"
              isDisabled={isFrozen}
            />
          </VerticalFormGroup>
          <VerticalFormGroup
            inputId="salesMargin"
            label="secondaryMarket.saleMarginInformation.salesMarginAdjusted"
            className="col-md-6"
          >
            <AmountWithUnit
              id="salesMargin"
              value={salesMargin}
              onChange={onSalesMarginChanged}
              unit={amountUnit}
              e2e="salesMarginAdjusted"
              isDisabled={isFrozen}
            />
          </VerticalFormGroup>
        </div>
      </div>
    </Block>
  );
};

CpOrderSalesMarginInformation.displayName = 'CpOrderSalesMarginInformation';
